const getDeviceModels = state => state.deviceModels
const getDeviceDataToCapture = state => state.deviceDataToCapture
const getDeviceProtocols = state => state.deviceProtocols
const getDeviceCommandTypes = state => state.deviceCommandTypes
const getDeviceCommandStates = state => state.deviceCommandStates
const getChannels = state => state.channels
const getCameraPositionType = state => state.cameraPositionType
const getDeviceHealthCheckTypes = state => state.deviceHealthCheckTypes
const getVideoStreamQualityTypes = state => state.videoStreamQualityTypes
const getSpeedUnitTypes = state => state.speedUnitTypes
const getLanguages = state => state.languages
const getLicenses = state => state.licenses
const getRoles = state => state.roles
const getFuelTypes = state => state.fuelTypes
const getVehicleTypes = state => state.vehicleTypes
const getEventTypes = state => state.eventTypes
const getEventCategories = state => state.eventCategories
const getEventClassifications = state => state.eventClassifications
const getThresholdLevels = state => state.thresholdLevels
const getAlarmPipelines = state => state.alarmPipelines
const getTimelineBlockStatuses = state => state.timelineBlockStatuses
const getTimeZones = state => state.timeZones
const getBrandImageTypes = state => state.brandImageTypes

export default {
    getDeviceModels,
    getDeviceDataToCapture,
    getDeviceProtocols,
    getDeviceCommandTypes,
    getDeviceCommandStates,
    getChannels,
    getCameraPositionType,
    getDeviceHealthCheckTypes,
    getVideoStreamQualityTypes,
    getSpeedUnitTypes,
    getLanguages,
    getLicenses,
    getRoles,
    getFuelTypes,
    getVehicleTypes,
    getEventTypes,
    getEventCategories,
    getEventClassifications,
    getThresholdLevels,
    getAlarmPipelines,
    getTimelineBlockStatuses,
    getTimeZones,
    getBrandImageTypes
};
